import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import { withNamespaces } from 'react-i18next'
import { User } from 'lucide-react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import AppRentalHeader from '../containers/AppRentalHeader'
import { putUpdatePrerental } from '../actions/qrsrental'
import NmStepBarRental from '../components/NmStepBarRental'

const TIMER_MINUTES = 5

class PhoneRentalView extends React.Component {
  constructor(props) {
    super(props)

    const state = props.location.state || {}

    this.state = {
      phoneNumber: state.phoneNumber || '',
      mail: state.mail || '',
      confirmMail: '',
      customerName: state.customerName || '',
      idNumber: state.idNumber || '',
      confirmReservation: false,
      newsletterAcceptance: false,
      isValidEmail: state.mail ? this.validateEmail(state.mail) : false,
      showExitDialog: false,
      timerSeconds: TIMER_MINUTES * 60,
      timerExpired: false,
    }

    this._unblockHistory = null
    this._timerInterval = null

    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this)
    this.handleMailChange = this.handleMailChange.bind(this)
    this.handleConfirmMailChange = this.handleConfirmMailChange.bind(this)
    this.handleCustomerNameChange = this.handleCustomerNameChange.bind(this)
    this.handleIdNumberChange = this.handleIdNumberChange.bind(this)
    this.handleLeave = this.handleLeave.bind(this)
    this.goTo = this.goTo.bind(this)
  }

  validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  removeAccents(str) {
    return str.normalize('NFD').replace(/[̀-ͯ]/g, '')
  }

  handlePhoneNumberChange(value, countryData) {
    let cleaned = value
    if (countryData && countryData.dialCode) {
      const dc = countryData.dialCode
      cleaned = cleaned.replace(/^\+/, '')
      if (cleaned.startsWith(dc) && cleaned.slice(dc.length).startsWith(dc)) {
        cleaned = cleaned.slice(dc.length)
      }
      const afterDc = cleaned.slice(dc.length)
      if (afterDc.startsWith('00' + dc)) {
        cleaned = dc + afterDc.slice(('00' + dc).length)
      }
      cleaned = cleaned.replace(/[^\d]/g, '')
    }
    this.setState({ phoneNumber: cleaned })
  }

  handleCustomerNameChange(event) {
    this.setState({ customerName: this.removeAccents(event.target.value) })
  }

  handleMailChange(event) {
    const mail = event.target.value
    this.setState({ mail, isValidEmail: this.validateEmail(mail) })
  }

  handleConfirmMailChange(event) {
    this.setState({ confirmMail: event.target.value })
  }

  handleIdNumberChange(event) {
    this.setState({ idNumber: event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '') })
  }

  componentDidMount() {
    const { timeStamp } = this.props.location.state || {}

    if (timeStamp) {
      const expiresAt = new Date(timeStamp).getTime() + TIMER_MINUTES * 60 * 1000
      this._timerInterval = setInterval(() => {
        const remaining = Math.max(0, Math.floor((expiresAt - Date.now()) / 1000))
        this.setState({ timerSeconds: remaining })
        if (remaining === 0) {
          clearInterval(this._timerInterval)
          this.setState({ timerExpired: true, showExitDialog: true })
        }
      }, 1000)
    }

    this._unblockHistory = history.block(() => {
      this.setState({ showExitDialog: true })
      return false
    })

    window.addEventListener('beforeunload', this._onBeforeUnload)
  }

  componentWillUnmount() {
    if (this._unblockHistory) this._unblockHistory()
    if (this._timerInterval) clearInterval(this._timerInterval)
    window.removeEventListener('beforeunload', this._onBeforeUnload)
  }

  _onBeforeUnload = (e) => {
    e.preventDefault()
    e.returnValue = ''
  }

  handleLeave() {
    if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null; }
    const { qr } = this.props.location.state || {}
    history.push(`/qrsale/${qr}`)
  }

  isContinueDisabled() {
    const { qrData } = this.props
    const requiresId = qrData?.requireIdNumber
    const { phoneNumber, mail, confirmMail, confirmReservation, customerName, idNumber, timerExpired } = this.state
    if (timerExpired) return true
    const emailsMatch = mail.toLowerCase() === confirmMail.toLowerCase()
    return (
      phoneNumber.length < 6 ||
      !this.validateEmail(mail) ||
      !emailsMatch ||
      !confirmReservation ||
      customerName.length === 0 ||
      (requiresId && idNumber.length < 5)
    )
  }

  goTo() {
    if (this.isContinueDisabled()) return

    const {
      zoneSelected, descriptionZone, selectedLocker, lockerPrice, lockerAssigned,
      prerentCode, prerentTime, totalDays, startDate, endDate, qrType, qr,
      timeStamp, customerId
    } = this.props.location.state

    this.props.putUpdatePrerental(prerentCode, {
      PrerentName: this.state.customerName,
      PrerentPhone: this.state.phoneNumber,
      PrerentEmail: this.state.mail,
    })

    if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null; }

    this.props.push('/PaymentRentalView', {
      zoneSelected, descriptionZone, selectedLocker, lockerPrice, lockerAssigned,
      prerentCode, prerentTime, totalDays, startDate, endDate, qrType, qr,
      timeStamp, customerId,
      customerName: this.state.customerName,
      phoneNumber: this.state.phoneNumber,
      mail: this.state.mail,
      idNumber: this.state.idNumber,
      newsletterAcceptance: this.state.newsletterAcceptance,
      confirmReservation: this.state.confirmReservation,
    })
  }

  renderTimer() {
    const { t } = this.props
    const { timerSeconds } = this.state
    const mins = String(Math.floor(timerSeconds / 60)).padStart(2, '0')
    const secs = String(timerSeconds % 60).padStart(2, '0')
    const isWarning = timerSeconds < 120
    const isUrgent = timerSeconds < 60

    return (
      <div className={`nm-phone-timer${isUrgent ? ' nm-phone-timer-urgent' : isWarning ? ' nm-phone-timer-warning' : ''}`}>
        <div className="nm-phone-timer-left">
          <User size={20} />
          <span className="nm-phone-timer-label">{t('Tiempo restante para completar la reserva')}</span>
        </div>
        <span className="nm-phone-timer-count">{mins}:{secs}</span>
      </div>
    )
  }

  renderExitDialog() {
    const { t } = this.props
    const { timerExpired } = this.state

    return (
      <div className="nm-exit-overlay">
        <div className="nm-exit-dialog">
          <span className="nm-exit-dialog-icon">{timerExpired ? '⏰' : '🚪'}</span>
          <h4 className="nm-exit-dialog-title">
            {timerExpired ? t('Tiempo agotado') : t('¿Salir de la reserva?')}
          </h4>
          <p className="nm-exit-dialog-body">
            {timerExpired
              ? t('El tiempo para completar tu reserva ha expirado. La pre-reserva se liberará automáticamente.')
              : t('Si sales ahora perderás la pre-reserva de taquillas. La selección se liberará automáticamente.')
            }
          </p>
          <div className="nm-exit-dialog-actions">
            {!timerExpired && (
              <button className="nm-exit-btn-stay" onClick={() => this.setState({ showExitDialog: false })}>
                {t('Continuar reserva')}
              </button>
            )}
            <button className="nm-exit-btn-leave" onClick={this.handleLeave}>
              {t('Salir')}
            </button>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { t, qrData } = this.props
    const { terms } = this.props.location.state || {}
    const requiresId = qrData?.requireIdNumber
    const { mail, confirmMail, showExitDialog } = this.state

    const emailsMatch = !confirmMail || mail.toLowerCase() === confirmMail.toLowerCase()

    return (
      <div className="rentalBackground">
        <AppRentalHeader />
        <NmStepBarRental step={3} />
        <div className="nm-page">

          {this.renderTimer()}

          <div className="nm-form">
            <User className="nm-form-icon" strokeWidth={1} />

            <p style={{ textAlign: 'center', fontSize: '0.88rem', color: '#6b7280', margin: '0 0 4px' }}>
              {t('Tu teléfono se vinculará a la taquilla reservada para poder recuperar el PIN')}
            </p>

            {/* NAME */}
            <div className="nm-uf-row">
              <div className="nm-uf-btn">
                <span className="nm-uf-label">{t('Nombre Completo*')}</span>
                <input
                  className="nm-input"
                  name="name"
                  type="text"
                  value={this.state.customerName}
                  onChange={this.handleCustomerNameChange}
                  placeholder={t('Introduce tu nombre')}
                />
              </div>
            </div>

            {/* EMAIL */}
            <div className="nm-uf-row">
              <div className="nm-uf-btn">
                <span className="nm-uf-label">{t('Email*')}</span>
                <input
                  className="nm-input"
                  name="lockerEmail"
                  type="email"
                  value={this.state.mail}
                  onChange={this.handleMailChange}
                  autoCapitalize="none"
                  placeholder={t('Introduce tu email')}
                />
              </div>
            </div>

            {/* CONFIRM EMAIL */}
            <div className={`nm-uf-row${!emailsMatch ? ' nm-uf-row-error' : ''}`}>
              <div className="nm-uf-btn">
                <span className="nm-uf-label">{t('Confirmar Email*')}</span>
                <input
                  className="nm-input"
                  name="confirmEmail"
                  type="email"
                  value={this.state.confirmMail}
                  onChange={this.handleConfirmMailChange}
                  autoCapitalize="none"
                  placeholder={t('Repite tu email')}
                />
              </div>
              {!emailsMatch && (
                <span className="nm-uf-error">{t('Los emails no coinciden')}</span>
              )}
            </div>

            {/* PHONE */}
            <div className="nm-uf-row nm-phone-input-wrap">
              <div className="nm-uf-btn">
                <span className="nm-uf-label">{t('Teléfono*')}</span>
                <PhoneInput
                  country="es"
                  value={this.state.phoneNumber}
                  onChange={this.handlePhoneNumberChange}
                  inputClass="nm-input"
                  containerStyle={{ position: 'relative' }}
                  pattern="[0-9]*"
                  placeholder={t('Introduce tu teléfono')}
                  countryCodeEditable={false}
                />
              </div>
            </div>

            {/* ID NUMBER (conditional) */}
            {requiresId && (
              <div className="nm-uf-row">
                <div className="nm-uf-btn">
                  <span className="nm-uf-label">{t('Documento de Identidad*')}</span>
                  <input
                    className="nm-input"
                    name="idNumber"
                    type="text"
                    value={this.state.idNumber}
                    onChange={this.handleIdNumberChange}
                    autoCapitalize="characters"
                    placeholder={t('DNI / NIE / Pasaporte')}
                    maxLength={20}
                  />
                </div>
              </div>
            )}

            {/* TERMS CHECKBOX */}
            <label className="nm-checkbox">
              <input
                type="checkbox"
                checked={this.state.confirmReservation}
                onChange={() => this.setState({ confirmReservation: !this.state.confirmReservation })}
              />
              <span className="nm-slider" />
              <span className="nm-checkbox-label">
                {t('Confirmo que he leído y acepto los')}{' '}
                <a href={terms} target="_blank" rel="noopener noreferrer" className="nm-terms-link">
                  {t('términos y condiciones')}
                </a>
              </span>
            </label>

            <button
              className={`nm-btn-continue${this.isContinueDisabled() ? ' disabled' : ''}`}
              disabled={this.isContinueDisabled()}
              onClick={this.goTo}
            >
              {t('Continuar')}
            </button>

            <p className="nm-phone-privacy">
              {t('*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.')}
            </p>
          </div>
        </div>

        {showExitDialog && this.renderExitDialog()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr,
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  putUpdatePrerental: bindActionCreators(putUpdatePrerental, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PhoneRentalView))
